import { Toaster } from "react-hot-toast";

const ToastNotification = () => {
  return (
    <Toaster
      position="top-center"
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        className: "",
        duration: 4000,
        style: {
          background: "#ffffff",
          color: "#3A4374",
        },
        success: {
          duration: 3000,
          iconTheme: {
            primary: "#198754",
            secondary: "#ffffff",
          },
        },
        error: {
          iconTheme: {
            primary: "#D73737",
            secondary: "#ffffff",
          },
        },
      }}
    />
  );
};

export default ToastNotification;
